import { LegalEntity } from '@mkp/legal-entity/models';
import { Identifiable, ViewRevisionEmbed } from '@mkp/shared/models';
import { AccountLinks } from './account.dto';
import { AccountSettingsAts } from './account-settings-ats.model';

export enum AccountState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum AccountType {
  Default = 'DEFAULT',
  Network = 'NETWORK',
}

export interface Account extends Identifiable, ViewRevisionEmbed {
  name: string;
  settings: AccountSettings;
  legalEntity: LegalEntity;
  legalEntityId?: string;
  state: AccountState;
  type: AccountType;
  computed: {
    canCreateUser: boolean;
  };
  _links: AccountLinks;
}

export interface AccountSettings {
  ats: AccountSettingsAts;
  freeProductsAllowed: boolean;
  mfaEnabled: boolean;
}
